import { render } from "./DrawerHead.vue?vue&type=template&id=cacf87c4&scoped=true"
import script from "./DrawerHead.vue?vue&type=script&lang=js"
export * from "./DrawerHead.vue?vue&type=script&lang=js"

import "./DrawerHead.vue?vue&type=style&index=0&id=cacf87c4&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cacf87c4"]])

export default __exports__